import Vue from 'vue'

import lang from 'quasar/lang/ru.js'
import '@quasar/extras/material-icons/material-icons.css'
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QScrollArea,
  QInnerLoading,
  QSpinnerDots,
  QSeparator,
  QTable,
  QTh,
  QTr,
  QTd,
  QInput,
  Ripple,
  QSpace,
  QSplitter,
  QToggle,
  QSelect,
  QTabPanels,
  QTabPanel,
  QTabs,
  QTab,
  QCard,
  QImg,
  QBtnToggle,
  QOptionGroup,
  QTooltip,
  QMenu,
  QDialog,
  QCardSection,
  QCardActions,
  QPopupEdit,
  QForm,
  QAvatar,
  QInfiniteScroll,
  QPageSticky,
  ClosePopup,
} from 'quasar'
import { NotifyHelper } from 'vue-kit'

Vue.use(Quasar, {
  config: {},
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QScrollArea,
    QInnerLoading,
    QSpinnerDots,
    QSeparator,
    QTable,
    QTh,
    QTr,
    QTd,
    QInput,
    QSpace,
    QSplitter,
    QToggle,
    QSelect,
    QTabs,
    QTabPanels,
    QTabPanel,
    QTab,
    QCard,
    QImg,
    QBtnToggle,
    QOptionGroup,
    QTooltip,
    QMenu,
    QDialog,
    QCardSection,
    QCardActions,
    QPopupEdit,
    QForm,
    QInfiniteScroll,
    QAvatar,
    QPageSticky,
  },
  directives: { Ripple, ClosePopup },
  plugins: { Notify: NotifyHelper.notify },
  lang: lang,
})
